import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { ExportQuery, ExportState, ExportStore } from '../../state';

@Injectable({ providedIn: 'root' })
export class ExportUserDataService extends AbstractUserRelatedDataService<ExportState> {
  constructor(readonly http: HttpClient, readonly store: ExportStore, readonly query: ExportQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'exports-lastseen',
        starred: 'exports-starred',
      },
    });
  }
}
